const state = {
  userType: "",
  userInfo: null,
};
const getters = {
  userType: state => state.userType,
  userInfo: state => state.userInfo,
  isAdmin: state => state.userType === "admin",
  isStoreKeeper: state => state.userType === "loja",
  isAffiliate: state => state.userType === "afiliado",
  isEventProfile: state => state.userInfo.perfil === "EVENTO",
  editEvent: state => state.userInfo.editar_evento,
};
const actions = {
  setUserType({ commit }, userType) {
    commit("setUserType", userType);
  },
  setUserInfo({ commit }, userInfo) {
    commit("setUserInfo", userInfo);
  },
};
const mutations = {
  setUserType(state, userType) {
    state.userType = userType;
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
